import { apiClient } from './apiService';

/**
 * Monitoring Service
 * Connects to Backend Monitoring Endpoints
 */

export const monitoringService = {
  /**
   * Check if monitoring service is available
   */
  async checkStatus() {
    const response = await apiClient.get('/monitoring/status');
    return response.data;
  },

  /**
   * Get system health (CPU, Memory, Pool)
   */
  async getHealth() {
    const response = await apiClient.get('/monitoring/health');
    return response.data;
  },

  /**
   * Get production metrics (6 KPIs)
   */
  async getMetrics() {
    const response = await apiClient.get('/monitoring/metrics');
    return response.data;
  },

  /**
   * Get active and completed requests
   */
  async getRequests() {
    const response = await apiClient.get('/monitoring/requests');
    return response.data;
  },

  /**
   * Get browser pool details
   */
  async getBrowsers() {
    const response = await apiClient.get('/monitoring/browsers');
    return response.data;
  },

  /**
   * Get endpoint statistics
   */
  async getEndpointStats() {
    const response = await apiClient.get('/monitoring/endpoints/stats');
    return response.data;
  },

  /**
   * Get janitor (cleanup) logs
   */
  async getJanitorLogs(limit = 50) {
    const response = await apiClient.get('/monitoring/logs/janitor', {
      params: { limit }
    });
    return response.data;
  },

  /**
   * Get error logs
   */
  async getErrorLogs(limit = 50) {
    const response = await apiClient.get('/monitoring/logs/errors', {
      params: { limit }
    });
    return response.data;
  },

  // Control Actions

  /**
   * Force cleanup of browser pool
   */
  async forceCleanup() {
    const response = await apiClient.post('/monitoring/actions/cleanup');
    return response.data;
  },

  /**
   * Kill specific browser
   */
  async killBrowser(browserId) {
    const response = await apiClient.post('/monitoring/actions/kill-browser', {
      browser_id: browserId
    });
    return response.data;
  },

  /**
   * Restart specific browser
   */
  async restartBrowser(browserId) {
    const response = await apiClient.post('/monitoring/actions/restart-browser', {
      browser_id: browserId
    });
    return response.data;
  },

  /**
   * Reset statistics
   */
  async resetStats() {
    const response = await apiClient.post('/monitoring/actions/reset-stats');
    return response.data;
  }
};

export default monitoringService;

